// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import React, { useState } from 'react';
import { PlasmicGetStarted } from './plasmic/collect_wise_draft/PlasmicGetStarted';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  collection,
  updateDoc,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { db } from '../firebase';

function GetStarted_(props, ref) {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [merchantName, setMerchantName] = useState('');

  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      'Are you sure you want to leave? All provided data will be lost.';
    e.returnValue = message;
    return message;
  };

  return (
    <PlasmicGetStarted
      root={{ ref }}
      {...props}
      merchantName={{
        value: merchantName,
        onChange: (e) => {
          setMerchantName(e.target.value);
        },
      }}
      nextButton={{
        onClick: async () => {
          window.addEventListener('beforeunload', handleBeforeUnload);
          // send the user home immediately (optional)
          navigate('/');
          try {
            console.log('Fetching collection...');
            const q = query(
              collection(db, 'userInfo'),
              where('user', '==', currentUser.uid)
            );
            const querySnapshot = await getDocs(q);
            console.log('Got query snapshot', querySnapshot);

            if (querySnapshot.empty) {
              console.error('No userInfo document found for current user');
              return;
            }

            const userInfoDoc = querySnapshot.docs[0];
            console.log('UserInfoDocRef', userInfoDoc.ref, 'userInforDocId', userInfoDoc.id);
            await updateDoc(userInfoDoc.ref, {
              merchantName: merchantName,
            });

            console.log(`Updated merchantName for doc ${userInfoDoc.id}`);
          } catch (err) {
            console.error('Error updating merchantName:', err);
          } finally {
            window.removeEventListener('beforeunload', handleBeforeUnload);
          }
        },
      }}
    />
  );
}

const GetStarted = React.forwardRef(GetStarted_);

export default GetStarted;
